import '../input/select-input';

import{ html, LitElement, TemplateResult } from 'lit';
import { customElement, query, queryAll } from 'lit/decorators.js';
import { SignalWatcher } from '@lit-labs/signals';

@customElement('form-element')
export class FormElement extends SignalWatcher(LitElement) {

    // Props

    @query('form')
    _form!: HTMLFormElement;

    @queryAll('input[required], select[required]')
    _requiredInputs!: NodeListOf<HTMLInputElement|HTMLSelectElement>;

    // Lifecycle Hooks

    firstUpdated() {
        
        // add classes
        this.classList.add('Form');
    }

    submitButtonTemplate(name: string = 'submit', label: string ='Submit', disabled: boolean = false): TemplateResult {
        return html`
            <div class="Form-block">
                <button-input
                    name="${ name }"
                    ?disabled="${ disabled }"
					ariaLabel="submit"
                    @click="${ this._submit }">
                    <div slot="label">
                        ${ label }
                    </div>
                </button-input>
            </div>
        `;
    }

    hiddenInputTemplate(name: string, value: string): TemplateResult {
        return html`
            <input 
                type="hidden" 
                name="${ name }" 
                value="${ value }"
            />
        `;
    }

    alertTemplate(label: string): TemplateResult {
        return html`
            <div class="u-alert">${ label }</div>
        `;
    }

    messageTemplate(label: string): TemplateResult {
        return html`
            <div class="u-message">${ label }</div>
        `;
    }

    // Getters

    get _isComplete() {
        return [...this._requiredInputs].every((input) => input.value);
    }

    get _formData() {
        return this._form ? new FormData(this._form) : null;
    }

    // Methods

    protected async _validate() {
        if (this._isComplete) await this._submit();
    }

    protected async _submit() {
        this._form.submit();
    }

}